import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";

// A component to protect routes that require authentication and optionally specific roles (e.g. admin)
export default function ProtectedRoute({ children, requiredRole }) {
  const { token } = useAuth();

  if (!token) {
    // No token, return to the public landing page.
    return <Navigate to="/" replace />;
  }

  // Decode the JWT to get the user's role and check if it's valid
  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch (error) {
    // Token is invalid
    console.error("Invalid JWT:", error);
    return <Navigate to="/" replace />;
  }

  const { role, exp } = decoded;

  // check if token is expired
  if (exp && Date.now() >= exp * 1000) {
    console.warn("JWT expired");
    return <Navigate to="/" replace />;
  }

  // Check role if required
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
